export enum DeviceTypeKeys {
  'NONE',
  'GATE',
  'SIMCARD',
  'SZT',
}

export enum DetailOpenMode {
  'REGULAR',
  'PLOTS',
  'MONITORING',
}

export interface DeviceTypeAttr {
  id: string;
  translateString: string;
  translateBasicString: string;
  icon: string;
  fontSet?: string;
}

type DeviceType = Record<DeviceTypeKeys, DeviceTypeAttr>;

export interface DeviceTypeInterface extends DeviceType {}

export const DeviceTypes: DeviceTypeInterface = {
  [DeviceTypeKeys.NONE]: {
    id: 'NONE',
    translateString: 'devices.types.none',
    translateBasicString: '',
    icon: '',
  },
  [DeviceTypeKeys.GATE]: {
    id: 'EFAtronic',
    translateString: 'devices.types.gate',
    translateBasicString: 'devices.detail.basic.gate.',
    icon: 'fa-gear',
    fontSet: 'fa',
  },
  [DeviceTypeKeys.SIMCARD]: {
    id: 'SIM',
    translateString: 'devices.types.sim-card',
    translateBasicString: 'devices.detail.basic.sim-card.',
    icon: 'sim_card',
  },
  [DeviceTypeKeys.SZT]: {
    id: 'SZT',
    translateString: 'devices.types.babel-fish',
    translateBasicString: 'devices.detail.basic.babel-fish.',
    icon: 'developer_board',
  },
};
